import React from 'react';
import PropTypes from 'prop-types';

import gettext from '@eb/gettext';
import { Button } from '@eb/eds-button';
import { Link } from 'react-router-dom';
import { TYPE_BUTTON, TYPE_LINK } from '@eb/eds-button';

import './searchPaginator.scss';

const NextButton = ({ handleGetPage, currentPage, isDisabled, nextUrl }) => (
    <div className="eds-l-pad-left-4">
        <Button
            type={isDisabled ? TYPE_BUTTON : TYPE_LINK}
            href={nextUrl}
            onClick={handleGetPage.bind(null, currentPage + 1)}
            disabled={isDisabled}
            aria-label={gettext('Go to next page')}
        >
            {gettext('Next')}
        </Button>
    </div>
);

const PreviousButton = ({
    handleGetPage,
    isDisabled,
    currentPage,
    prevUrl,
}) => (
    <div className="eds-l-pad-right-4">
        <Button
            disabled={isDisabled}
            href={prevUrl}
            type={isDisabled ? TYPE_BUTTON : TYPE_LINK}
            onClick={handleGetPage.bind(null, currentPage - 1)}
            aria-label={gettext('Go to previous page')}
        >
            {gettext('Previous')}
        </Button>
    </div>
);

const SetPageButton = ({
    page,
    currentPage,
    pageUrl,
    handleGetPage,
    classes,
    dataSpec,
}) => {
    const ellipsis = (
        <span className="eds-l-pad-hor-3 eds-text-color--grey-400">...</span>
    );

    let component = null;
    const leftEllipsis = page === 0 ? null : ellipsis;
    const rightEllipsis = page === 0 ? ellipsis : null;

    if (
        (page === 0 && currentPage >= 1) ||
        (page !== 0 && currentPage < page)
    ) {
        component = (
            <div
                className={`${classes} paginator__link eds-l-pad-top-2 eds-text-weight--heavy `}
                data-spec={dataSpec}
            >
                {leftEllipsis}
                <Link onClick={handleGetPage.bind(null, page)} to={pageUrl}>
                    {page + 1}
                </Link>
                {rightEllipsis}
            </div>
        );
    }

    return component;
};

export class SearchPaginator extends React.PureComponent {
    static propTypes = {
        handleGetPage: PropTypes.func.isRequired,
        currentPage: PropTypes.number,
        isNextDisabled: PropTypes.bool,
        nextUrl: PropTypes.string,
        prevUrl: PropTypes.string,
        firstPageUrl: PropTypes.string,
        lastPageUrl: PropTypes.string,
        pageCount: PropTypes.number,
    };

    render() {
        const {
            currentPage,
            handleGetPage,
            isNextDisabled,
            nextUrl,
            prevUrl,
            firstPageUrl,
            pageCount,
            lastPageUrl,
        } = this.props;

        let isPrevDisabled = false;

        if (currentPage === 0) {
            isPrevDisabled = true;
        }

        return (
            <div className="paginator eds-align--left eds-l-mar-vert-8">
                <PreviousButton
                    isDisabled={isPrevDisabled}
                    handleGetPage={handleGetPage}
                    currentPage={currentPage}
                    prevUrl={prevUrl}
                />
                <SetPageButton
                    currentPage={currentPage}
                    page={0}
                    pageUrl={firstPageUrl}
                    handleGetPage={handleGetPage}
                    dataSpec="paginator__first-page-link"
                />
                <div className="paginator__current-page eds-text-color--ui-orange eds-text-weight--heavy">
                    <p>{currentPage + 1}</p>
                </div>
                <SetPageButton
                    currentPage={currentPage}
                    page={pageCount - 1}
                    pageUrl={lastPageUrl}
                    handleGetPage={handleGetPage}
                    dataSpec="paginator__last-page-link"
                />
                <NextButton
                    currentPage={currentPage}
                    handleGetPage={handleGetPage}
                    isDisabled={isNextDisabled}
                    nextUrl={nextUrl}
                />
            </div>
        );
    }
}
